import { UserOutlined } from '@ant-design/icons';
import { Button, Col, Input, Modal, Row, Space } from 'antd';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useInjectReducer, useInjectSaga } from 'store/core/@reduxjs/redux-injectors';
import { TeacherSaga } from 'store/teacher/shared/saga';
import * as FromTeacherSlice from '../../../store/teacher/shared/slice';
import { PASSWORD_PATTERN, PASSWORD_RULE_MESSAGE } from '_constants/default.constants';

interface CreateTeacher {
  isOpen: boolean;
  handleCancel: () => void;
  handleOk: () => void;
  subjectId: any;
}

interface IFormInput {
  nameTeacher: string;
  phone: number;
  password: string;
  rePassword: string;
}

function CreateTeacher({ isOpen, handleOk, handleCancel, subjectId }: CreateTeacher) {
  useInjectReducer({ key: FromTeacherSlice.sliceKey, reducer: FromTeacherSlice.reducer });
  useInjectSaga({ key: FromTeacherSlice.sliceKey, saga: TeacherSaga });
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    getValues,
    formState: { errors }
  } = useForm<IFormInput>();
  const onSubmit = (data: IFormInput) => {
    const teachers = [
      {
        fullname: data.nameTeacher,
        phone_number: data.phone,
        password: data.rePassword,
        subject_id: parseInt(subjectId)
      }
    ];
    dispatch(FromTeacherSlice.actions.addTeacher(teachers));
    handleCancel();
  };
  return (
    <Modal
      maskClosable={false}
      centered
      visible={isOpen}
      onCancel={() => handleCancel()}
      title="Thêm giáo viên"
      footer={null}>
      <div className="container">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row wrap justify="space-between" align="middle">
            <Col span={24} className="mb-5">
              <h4>Họ và tên</h4>
              <Controller
                name="nameTeacher"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Input
                    {...field}
                    status={errors?.nameTeacher?.type === 'required' ? 'error' : ''}
                    size="large"
                    placeholder="Nhập họ và tên"
                    type="text"
                    prefix={<UserOutlined />}
                  />
                )}
              />
              {errors?.nameTeacher?.type === 'required' && (
                <span className="text-error">Họ và tên không được để trống!</span>
              )}
            </Col>
            <Col span={24} className="mb-5">
              <h4>Số điện thoại</h4>
              <Controller
                name="phone"
                control={control}
                rules={{ required: true, pattern: /(((\+|)84)|0)(3|5|7|8|9)+([0-9]{8})\b/ }}
                render={({ field }) => (
                  <Input
                    {...field}
                    status={
                      errors?.phone?.type === 'required' || errors?.phone?.type === 'pattern'
                        ? 'error'
                        : ''
                    }
                    size="large"
                    placeholder="Nhập số điện thoại"
                    prefix={<i className="fas fa-mobile-alt" />}
                  />
                )}
              />
              {errors?.phone?.type === 'required' && (
                <span className="text-error">Số điện thoại không được để trống!</span>
              )}
              {errors?.phone?.type === 'pattern' && (
                <span className="text-error">Số điện thoại không đúng định dạng!</span>
              )}
            </Col>
            <Col span={24} className="mb-5">
              <h4>Mật khẩu</h4>
              <Controller
                name="password"
                control={control}
                rules={{ required: true, minLength: 4, pattern: PASSWORD_PATTERN }}
                render={({ field }) => (
                  <Input.Password
                    {...field}
                    status={errors?.password?.type === 'required' ? 'error' : ''}
                    size="large"
                    placeholder="Nhập mật khẩu"
                    prefix={<i className="fas fa-lock" />}
                  />
                )}
              />
              {errors?.password?.type === 'required' && (
                <span className="text-error">Mật khẩu không được để trống!</span>
              )}
              {errors?.password?.type === 'minLength' && (
                <span className="text-error">Mật khẩu có ít nhất 4 ký tự!</span>
              )}
              {errors?.password?.type === 'pattern' && (
                <span className="text-error">{PASSWORD_RULE_MESSAGE}</span>
              )}
            </Col>
            <Col span={24}>
              <h4>Nhập lại mật khẩu</h4>
              <Controller
                name="rePassword"
                control={control}
                rules={{
                  required: true,
                  validate: (value) => value === getValues('password')
                }}
                render={({ field }) => (
                  <Input.Password
                    {...field}
                    status={errors?.rePassword?.type === 'required' ? 'error' : ''}
                    size="large"
                    placeholder="Nhập lại mật khẩu"
                    prefix={<i className="fas fa-lock" />}
                  />
                )}
              />
              {errors?.rePassword?.type === 'required' && (
                <span className="text-error">Nhập lại mật khẩu không được để trống!</span>
              )}
              {errors?.rePassword?.type === 'validate' && (
                <span className="text-error">Nhập lại mật khẩu không trùng khớp!</span>
              )}
            </Col>
          </Row>
          <div className="flex justify-end mt-20">
            <Button key="back" size="large" onClick={handleCancel}>
              Đóng
            </Button>
            <button type="submit" className="btn btn-add ml-10">
              Thêm mới
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default React.memo(CreateTeacher);
